import React from 'react';

export interface FocusRingState {
    enabled: boolean;
}

export interface FocusRingProviderProps {
    enabled: boolean;
    children: React.ReactNode;
}

const defaultFocusRingState: FocusRingState = {
    enabled: false,
};

export const FocusRingContext = React.createContext(defaultFocusRingState);

/**
 * Enable or disable a Focus Ring for each interactive component in a tree.
 *
 * The main use case for this provider is adding the focus ring to Public Content and not to the Editor.
 */
export function FocusRingProvider(props: FocusRingProviderProps): React.ReactElement {
    const { children, enabled } = props;
    const value = React.useMemo(
        () => ({
            enabled,
        }),
        [enabled]
    );
    return <FocusRingContext.Provider value={value}>{children}</FocusRingContext.Provider>;
}
